/* nls8-es2.js (25-oct) · animación de la ficha de España: aparición al hacer scroll (fade-up escalonado), contadores 6 · 9 · 20 y vídeos en bucle.
   Solo toca lo que está por DEBAJO del primer pantallazo (la compra no se mueve: ni CLS ni retraso del botón). Sin IntersectionObserver no hace nada y
   la página se ve completa. Los estilos están en nls8-es2.css (bloque 7). Deshacer: quitar el <script> de nls8-pagina-es2. */
(function(){
  if (window.__es2) return; window.__es2 = 1;
  var d = document, root = d.documentElement;
  function cada(sel, fn){ [].forEach.call(d.querySelectorAll(sel), fn); }
  function listo(fn){ if (d.readyState !== 'loading') fn(); else d.addEventListener('DOMContentLoaded', fn); }
  function bajoElPliegue(el){ var r = el.getBoundingClientRect(); return r.top > (window.innerHeight || 800) * 0.94; }

  listo(function(){
    if (!('IntersectionObserver' in window)) return;
    root.classList.add('es2-js');

    /* 1 · aparición al hacer scroll */
    var SEL = [
      '.es2-hero__t', '.es2-hero__f',
      '.es2-sec .n8-in > .es2-kick', '.es2-sec .n8-in > .n8-h', '.es2-sec .n8-in > .es2-h2', '.es2-sec .n8-in > .n8-p', '.es2-sec .n8-in > .es2-sub', '.es2-sec .n8-in > .es2-centro',
      '.es2-dolor__g > .es2-card', '.es2-datos__g > li', '.es2-datos__v', '.es2-pasos__g > li',
            '.es2-faq .n8-acc > details', '.es2-oferta__g > .es2-of', '.es2-oferta__nota',
      '.n8-cf .n8-in > *', '.n8-ugc .n8-in > *', '.n8-vs .n8-in > *', '.n8-gar .n8-in > *'
    ].join(',');
    var nuevos = [];
    cada(SEL, function(el){
      if (el.closest('.n8-compra') || el.classList.contains('es2-rv')) return;
      if (!bajoElPliegue(el)) return;
      el.classList.add('es2-rv'); nuevos.push(el);
    });
    var io = new IntersectionObserver(function(es){
      var lote = es.filter(function(e){ return e.isIntersecting || e.boundingClientRect.bottom < 0; }).map(function(e){ return e.target; });
      if (!lote.length) return;
      lote.sort(function(a, b){ return (a.compareDocumentPosition(b) & 4) ? -1 : 1; });
      var cuenta = new Map();
      lote.forEach(function(el){
        var p = el.parentNode, n = cuenta.get(p) || 0; cuenta.set(p, n + 1);
        el.style.setProperty('--es2-i', Math.min(n, 5));
        io.unobserve(el);
        requestAnimationFrame(function(){ el.classList.add('es2-in'); });
        /* al acabar, se suelta la clase para que el hover de la tarjeta vuelva a mandar */
        setTimeout(function(){ el.classList.remove('es2-rv', 'es2-in'); el.style.removeProperty('--es2-i'); }, 1100 + Math.min(n, 5) * 120 + 400);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    nuevos.forEach(function(el){ io.observe(el); });
    var pend = nuevos.slice(), rqp = 0;
    function pasados(){
      pend = pend.filter(function(el){
        if (!el.classList.contains('es2-rv')) return false;
        if (el.getBoundingClientRect().bottom < 0) { io.unobserve(el); el.classList.remove('es2-rv', 'es2-in'); el.style.removeProperty('--es2-i'); return false; }
        return true; });
      if (!pend.length) window.removeEventListener('scroll', alBajar);
    }
    function alBajar(){ if (!rqp) rqp = requestAnimationFrame(function(){ rqp = 0; pasados(); }); }
    window.addEventListener('scroll', alBajar, { passive: true });

    /* 2 · contadores (6 · 9 · 20'): suben de 0 al número al entrar en pantalla; el número final ya está en el HTML */
    var cont = [];
    cada('.es2-datos__g li > b', function(b){
      var m = (b.textContent || '').trim().match(/^(\d+)(\D.*)?$/);
      if (!m || !bajoElPliegue(b)) return;
      b.__es2 = { n: parseInt(m[1], 10), suf: m[2] || '' };
      b.textContent = '0' + b.__es2.suf;
      cont.push(b);
    });
    function contar(b){
      var n = b.__es2.n, suf = b.__es2.suf, dur = 1500, t0 = null;
      function paso(t){
        if (t0 === null) t0 = t;
        var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3);
        b.textContent = Math.round(n * e) + suf;
        if (k < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (cont.length) {
      var ioc = new IntersectionObserver(function(es){
        es.forEach(function(e){ if (e.isIntersecting) { ioc.unobserve(e.target); contar(e.target); } });
      }, { threshold: 0.6 });
      cont.forEach(function(b){ ioc.observe(b); });
    }

    /* 3 · vídeos en bucle: reproducir solo mientras se ven (ahorra batería y datos) */
    var vids = d.querySelectorAll('video[data-es2-vid]');
    if (vids.length) {
      var iov = new IntersectionObserver(function(es){
        es.forEach(function(e){
          var v = e.target;
          if (e.isIntersecting) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function(){}); }
          else { try { v.pause(); } catch (x) {} }
        });
      }, { threshold: 0.25 });
      [].forEach.call(vids, function(v){ v.muted = true; iov.observe(v); });
    }
  });
})();
